import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";

var Clip = /*#__PURE__*/function (_Vue) {
  _inherits(Clip, _Vue);

  var _super = _createSuper(Clip);

  function Clip() {
    var _this;

    _classCallCheck(this, Clip);

    _this = _super.apply(this, arguments);
    _this.clipToVisualize = 0;
    return _this;
  }

  _createClass(Clip, [{
    key: "numberOfClips",
    get: function get() {
      return this.$store.state.configurator.numberOfClips;
    },
    set: function set(value) {
      this.$store.commit("configurator/setNumberOfClips", value);
    }
  }, {
    key: "lentiClip",
    get: function get() {
      return this.$store.getters["configurator/lenti/clipLenses"];
    }
  }, {
    key: "selectedClips",
    get: function get() {
      return this.$store.state.configurator.lentiSoleClip;
    }
  }, {
    key: "correspondingFrontaleWithClip",
    get: function get() {
      return this.$store.getters["configurator/correspondingFrontalWithClip"];
    }
  }, {
    key: "correspondingClip",
    get: function get() {
      return this.$store.getters["configurator/correspondingClip"];
    }
  }, {
    key: "clipOn",
    get: function get() {
      return this.$store.state.configurator.clip != null;
    },
    set: function set(co) {
      var frontale = this.$store.state.configurator.frontale;

      if (frontale) {
        this.$store.commit("configurator/setClip", co ? this.correspondingClip : null);
      }
    }
  }, {
    key: "showClip",
    get: function get() {
      return this.$store.state.configurator.showClip;
    },
    set: function set(show) {
      this.$store.state.configurator.showClip = show;
    }
  }, {
    key: "setClipLensesModel",
    value: function setClipLensesModel(l) {
      var existingIdx = this.selectedClips.findIndex(function (selected) {
        return selected.ItemCode == l.ItemCode;
      });

      if (existingIdx != -1) {
        // Already selected — remove it
        this.$store.commit("configurator/removeClipLensesModel", l);
        this.clipToVisualize = this.selectedClips.length;
      } else {
        if (this.selectedClips.length < this.numberOfClips) {
          // Slot available — add it
          this.$store.commit("configurator/addClipLensesModel", l);
          this.clipToVisualize = this.selectedClips.length;
          this.$store.commit("configurator/setLenteClipToVisualize", l);
        } else if (this.selectedClips.length > 0) {
          // All slots full — replace the last one
          this.$store.commit("configurator/replaceClipLensesModel", {
            lens: l,
            index: this.selectedClips.length - 1
          });
          this.clipToVisualize = this.selectedClips.length;
          this.$store.commit("configurator/setLenteClipToVisualize", l);
        }
      }
    }
  }, {
    key: "changedNumberOfClips",
    value: function changedNumberOfClips(newV) {
      if (newV > 0 && !this.clipOn) {
        if (this.correspondingFrontaleWithClip) {
          this.$store.commit("configurator/setFrontal", this.correspondingFrontaleWithClip);
        }

        this.clipOn = this.correspondingClip;
        this.showClip = false;
      } else if (newV <= 0 && this.clipOn) {
        this.$store.commit("configurator/setLenteClipToVisualize", null);
        this.$store.commit("configurator/setClipLensesModels", []);
        this.clipOn = null;
      }

      if (this.selectedClips.length > newV) {
        this.selectedClips.splice(newV);
      }

      if (this.clipToVisualize > newV) {
        this.clipToVisualize = this.selectedClips.length;
      }
    }
  }, {
    key: "changedClipToVisualize",
    value: function changedClipToVisualize(newV) {
      if (!this.showClip && newV > 0 && this.numberOfClips > 0) {
        this.showClip = true;
      }

      if (newV == 0) {
        this.showClip = false;
      } else if (newV <= this.selectedClips.length) {
        this.$store.commit("configurator/setLenteClipToVisualize", this.selectedClips[newV - 1]);
      } else {
        this.$store.commit("configurator/setLenteClipToVisualize", null);
      }
    }
  }]);

  return Clip;
}(Vue);

__decorate([Watch("numberOfClips")], Clip.prototype, "changedNumberOfClips", null);

__decorate([Watch("clipToVisualize")], Clip.prototype, "changedClipToVisualize", null);

Clip = __decorate([Component({})], Clip);
export default Clip;